const clientlib = {};

clientlib.init = ({ api, api2, toast }) => {
  clientlib.api = api;
  clientlib.api2 = api2;
  clientlib.toast = toast;
};

export default clientlib;
